module.exports = __webpack_public_path__ + "img/thaddeus-stevens.366deadd.png";